import { CategoriesFinance } from "./pages/CategoriesFinance";
import { CategoriesFinanceForm } from "./pages/CategoriesFinanceForm";

export const CategoriesFinanceRoutes = [
  { path: "/financeiro/categorias", exact: true, component: CategoriesFinance },
  {
    path: "/financeiro/edit/:id/:categoryType",
    exact: true,
    component: CategoriesFinanceForm,
  },
  {
    path: "/financeiro/contas/novo/despesas",
    component: CategoriesFinanceForm,
  },
  {
    path: "/financeiro/contas/novo/receitas",
    component: CategoriesFinanceForm,
  },
];
